module.exports = __webpack_public_path__ + "img/plant_0_mobile.d6f23734.webp";